import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PessoaDadosModel } from '../models/pessoa-dados.model';
import { PessoaJuridicaModel } from '../models/pessoa-juridica.model';
import { PessoaDadosSimplicadosModel } from '../models/pessoa-simplificada.model';
import { PessoaModel } from '../models/pessoa.model';
import { UtilService } from '../util/util.service';
import { PESSOAFISICA, PESSOA, PESSOA_CONTROLE_ACESSO, BACK_END_CONTROLE_ACESSO } from '../../../app.constants';
import { PessoaCompletaModel } from '../models/pessoa-completa.model';

@Injectable()
export class PessoaService {

  constructor(private httpClient: HttpClient) { }


  getPessoasDadosSimplificado(centrus): Promise<PessoaDadosSimplicadosModel> {
    return this.httpClient
      .get<PessoaDadosSimplicadosModel>(`${PESSOAFISICA}/pessoaDadosSimplicados/${centrus}`)
      .toPromise();
  }

  getPessoas(centrus): Promise<PessoaDadosSimplicadosModel> {
    return this.httpClient
      .get<PessoaDadosSimplicadosModel>(`${BACK_END_CONTROLE_ACESSO}pessoaDadosSimplicadosDTO/${centrus}`)
      .toPromise();
  }

  getPessoaDadosCdCentrus(centrus: number): Promise<PessoaDadosModel> {
    return this.httpClient
      .get<PessoaDadosModel>(`${PESSOAFISICA}/pessoaDadosCdCentrus/${centrus}`)
      .toPromise();
  }

  getPessoaStCentrus(centrus: number): Promise<Boolean> {
    return this.httpClient
      .get<Boolean>(`${PESSOAFISICA}/stCentrus/${centrus}`)
      .toPromise();
  }

  getPessoaDadosCPF(cpf: string): Promise<PessoaDadosModel> {
    return this.httpClient
      .get<PessoaDadosModel>(`${PESSOAFISICA}/pessoaDadosCPF/${cpf}`)
      .toPromise();
  }

  getCdCentrusTitular(centrus: number): Promise<number> {
    return this.httpClient
      .get<number>(`${PESSOA}/cdCentrusTit/${centrus}`)
      .toPromise();
  }


  getObterPessoa(centrus: number) {
    return this.httpClient
      .get<PessoaModel>(`${PESSOA}/fisica/${centrus}`);
  }


  getPessoaJuridica(): Promise<PessoaJuridicaModel> {
    return this.httpClient
      .get<PessoaJuridicaModel>(`${PESSOA}/juridicas`)
      .toPromise();
  }

  getPessoa(centrus: number): Promise<PessoaCompletaModel> {
    return this.httpClient
      .get<PessoaCompletaModel>(`${PESSOA_CONTROLE_ACESSO}/${centrus}`)
      .toPromise();
  }


  getObterCPFArquivoPCD(centrus: number) {
    return this.httpClient
      .get(`${PESSOA}/cpfarquivopcd/${centrus}`)
      .toPromise();
  }



}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/services/pessoa.service.ts